import { gql } from 'graphql-request';

export const PROJECT_PLAN_DRAFT_FIELDS = gql`
  fragment ProjectPlanDraftFields on ProjectPlanDraftDto {
    draftId
    organizationId
    projectId
    purpose
    title
    status
    brief
    startDate
    endDate
    plan
    summary
    assumptions
    messages
    attachments
    lastChanges
    projectInput
    progress {
      step
      current
      total
      label
    }
    errorCode
    errorMessage
    model
    turnCount
    inputTokens
    outputTokens
    cacheReadInputTokens
    createdAt
    updatedAt
  }
`;

export const aiPlanningAvailable = gql`
  query aiPlanningAvailable {
    aiPlanningAvailable
  }
`;

export const projectPlanDraft = gql`
  query projectPlanDraft($draftId: String!) {
    projectPlanDraft(draftId: $draftId) {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const myProjectPlanDrafts = gql`
  query myProjectPlanDrafts {
    myProjectPlanDrafts {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const createProjectPlanDraft = gql`
  mutation createProjectPlanDraft($input: CreateProjectPlanDraftInput!) {
    createProjectPlanDraft(input: $input) {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const reviseProjectPlanDraft = gql`
  mutation reviseProjectPlanDraft($input: ReviseProjectPlanDraftInput!) {
    reviseProjectPlanDraft(input: $input) {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const retryProjectPlanDraft = gql`
  mutation retryProjectPlanDraft($input: RetryProjectPlanDraftInput!) {
    retryProjectPlanDraft(input: $input) {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const updateProjectPlanDraftPlan = gql`
  mutation updateProjectPlanDraftPlan($input: UpdateProjectPlanDraftPlanInput!) {
    updateProjectPlanDraftPlan(input: $input) {
      ...ProjectPlanDraftFields
    }
  }
  ${PROJECT_PLAN_DRAFT_FIELDS}
`;

export const importProjectPlanDraft = gql`
  mutation importProjectPlanDraft($input: ImportProjectPlanDraftInput!) {
    importProjectPlanDraft(input: $input) {
      taskId
      name
    }
  }
`;

export const saveProjectPlanDraftAsTemplate = gql`
  mutation saveProjectPlanDraftAsTemplate($input: SaveProjectPlanDraftAsTemplateInput!) {
    saveProjectPlanDraftAsTemplate(input: $input)
  }
`;

export const discardProjectPlanDraft = gql`
  mutation discardProjectPlanDraft($input: DiscardProjectPlanDraftInput!) {
    discardProjectPlanDraft(input: $input)
  }
`;

const ProjectPlanDraftGraphQL = {
  queries: {
    aiPlanningAvailable,
    projectPlanDraft,
    myProjectPlanDrafts,
  },
  mutations: {
    createProjectPlanDraft,
    reviseProjectPlanDraft,
    retryProjectPlanDraft,
    updateProjectPlanDraftPlan,
    importProjectPlanDraft,
    saveProjectPlanDraftAsTemplate,
    discardProjectPlanDraft,
  },
};

export default ProjectPlanDraftGraphQL;
